export default __webpack_public_path__ + "static/media/icon apps-add-01.afc4ab58.png";